import { render } from "./CGanttChartTime.vue?vue&type=template&id=589dadf2&scoped=true"
import script from "./CGanttChartTime.vue?vue&type=script&lang=js"
export * from "./CGanttChartTime.vue?vue&type=script&lang=js"

import "./CGanttChartTime.vue?vue&type=style&index=0&id=589dadf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589dadf2"]])

export default __exports__